/* Full-size desktop galleries follow the existing two-column purchase layout.
   Photo dimensions, carousel/3D controls, options and commerce remain unchanged. */
(function () {
  'use strict';
  var selector = '.ef-pd-gallery,.efx-pdp__gallery,.lxc__media';
  var bars = '#efGmOrderBar,#lxc-sticky,#efPd2Sticky,#efStandardSticky,.ef-standard-sticky,.ef-gas-sticky,.ef-fp-doors__sticky';
  var managed = new Map(), observed = new WeakSet(), queued = false;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(queue) : null;
  function watch(element) {
    if (resizeObserver && element && !observed.has(element)) { observed.add(element); resizeObserver.observe(element); }
  }
  function viewportEdges() {
    var header = document.querySelector('#efx-header'), top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 80, bottom = innerHeight;
    document.querySelectorAll(bars).forEach(function (bar) {
      watch(bar); var r = bar.getBoundingClientRect(), style = getComputedStyle(bar);
      if (style.position === 'fixed' && style.visibility !== 'hidden' && r.width && r.height && r.bottom >= innerHeight - 2 && r.top < innerHeight) bottom = Math.min(bottom, r.top);
    });
    watch(header); return { top: top + 16, bottom: bottom - 16 };
  }
  function twoColumnParent(gallery) {
    var child = gallery;
    for (var depth = 0; depth < 3 && child.parentElement; depth++, child = child.parentElement) {
      var parent = child.parentElement, box = child.getBoundingClientRect(), style = getComputedStyle(parent);
      if (!/grid|flex/.test(style.display)) continue;
      var alongside = Array.from(parent.children).some(function (peer) {
        if (peer === child) return false; var p = peer.getBoundingClientRect();
        return p.width > 150 && p.height > 100 && p.left >= box.right - 1;
      });
      if (alongside) return { target: child, parent: parent };
    }
    return null;
  }
  function restore(element, record) {
    ['position', 'top', 'align-self'].forEach(function (name) {
      var value = record[name]; if (value.value) element.style.setProperty(name, value.value, value.priority); else element.style.removeProperty(name);
    });
    element.removeAttribute('data-ef-gallery-follow'); element.style.removeProperty('--ef-gallery-follow-top');
    managed.delete(element);
  }
  function update() {
    queued = false; var active = new Set(), edges = viewportEdges();
    document.querySelectorAll(selector).forEach(function (gallery) {
      // The standard-product controller also owns native 3D reveal positioning.
      // Keep that working controller; do not race it with a second top writer.
      if (gallery.closest('.ef-standard-product-schema') && gallery.style.getPropertyValue('--ef-standard-gallery-top')) return;
      watch(gallery);
      if (innerWidth < 1025 || !gallery.getBoundingClientRect().height) return;
      var pair = twoColumnParent(gallery); if (!pair) return;
      var element = pair.target; active.add(element); watch(pair.parent); watch(element);
      if (!managed.has(element)) {
        var record = {}; ['position', 'top', 'align-self'].forEach(function (name) { record[name] = { value: element.style.getPropertyValue(name), priority: element.style.getPropertyPriority(name) }; });
        managed.set(element, record);
      }
      // A tall gallery first scrolls upward naturally, then follows with its lower
      // thumbnails/actions above the order bar. Nothing is scaled or clipped.
      var offset = Math.round(Math.min(edges.top, edges.bottom - element.getBoundingClientRect().height));
      element.setAttribute('data-ef-gallery-follow', 'active');
      element.style.setProperty('--ef-gallery-follow-top', offset + 'px');
      element.style.setProperty('position', 'sticky', 'important');
      element.style.setProperty('top', 'var(--ef-gallery-follow-top)', 'important');
      element.style.setProperty('align-self', 'start', 'important');
    });
    managed.forEach(function (record, element) { if (!active.has(element) || !element.isConnected) restore(element, record); });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function init() {
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    addEventListener('resize', queue); addEventListener('scroll', queue, { passive: true });
    document.addEventListener('load', queue, true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
